import { createDexColor } from "../../styleguide/onboarding/components/ui/dex-color-set/create-dex-color";

export const generateDexColorsFromLightModeColors = (
  colors = [],
  mode = "light"
) => {
  if (!colors?.length) return [];

  return colors.map((color) => createDexColor({ color, mode }));
};

export const formatToDexColors = (lightColors = [], darkColors = []) => {
  if (!lightColors?.length) return [];
  return lightColors.map((color) => {
    const darkColor = darkColors.find((clr) => clr.id === color.id);
    return {
      ...color,
      first: {
        accent: { light: color.first.accent, dark: darkColor?.first.accent },
        text: { light: color.first.text, dark: darkColor?.first.text },
      },
      second: {
        accent: { light: color.second.accent, dark: darkColor?.second.accent },
        text: { light: color.second.text, dark: darkColor?.second.text },
      },
      third: {
        accent: { light: color.third.accent, dark: darkColor?.third.accent },
        text: { light: color.third.text, dark: darkColor?.third.text },
      },
    };
  });
};

export const createDexColors = (styleguideSetup) => {
  const areDexColorsSetup = !!styleguideSetup?.dexSelectedColors?.light?.length;

  const lightColors = areDexColorsSetup
    ? styleguideSetup?.dexSelectedColors?.light
    : generateDexColorsFromLightModeColors(
        styleguideSetup?.selectedColors?.light
      );

  if (!lightColors?.length) return [];

  const darkColors = areDexColorsSetup
    ? styleguideSetup?.dexSelectedColors?.dark
    : generateDexColorsFromLightModeColors(
        styleguideSetup?.selectedColors?.dark,
        "dark"
      );

  return formatToDexColors(lightColors, darkColors);
};
